/* ../src/components/ConnectWallet.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal
} from "svelte/internal";

import store from "../store";
import { TezBridgeWallet } from "@taquito/tezbridge-wallet";
import { ThanosWallet } from "@thanos-wallet/dapp";
import config from "../config";

function create_fragment(ctx) {
	let p;
	let input;
	let input_class_value;
	let mounted;
	let dispose;

	return {
		c() {
			p = element("p");
			input = element("input");
			attr(input, "type", "checkbox");
			attr(input, "class", input_class_value = `${!/*$store*/ ctx[0].userAddress ? "warning" : "success"}`);
			attr(p, "class", "checkbox-wallet");
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, input);

			if (!mounted) {
				dispose = listen(input, "click", /*connectWallet*/ ctx[1]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*$store*/ 1 && input_class_value !== (input_class_value = `${!/*$store*/ ctx[0].userAddress ? "warning" : "success"}`)) {
				attr(input, "class", input_class_value);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(p);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $store;
	component_subscribe($$self, store, $$value => $$invalidate(0, $store = $$value));

	const connectWallet = async () => {
		// if user is not connected
		if (!$store.userAddress) {
			try {
				// checks if Thanos is installed
				if (await ThanosWallet.isAvailable()) {
					const wallet = new ThanosWallet("Tezos Token Faucet");
					await wallet.connect($store.network, { forcePermission: true });
					$store.Tezos.setWalletProvider(wallet);
					store.updateUserAddress(wallet.pkh);
				} else {
					const wallet = new TezBridgeWallet();
					$store.Tezos.setWalletProvider(wallet);
					store.updateUserAddress(await wallet.getPKH());
				}

				// gets user's token balance
				if ($store.tokenType === "fa12") {
					const contract = await $store.Tezos.wallet.at(config[$store.tokenType][$store.network]);
					const storage = await contract.storage();
					const account = await storage.ledger.get($store.userAddress);

					if (account) {
						store.updateUserBalance(account.balance.toNumber());
					} else {
						store.updateUserBalance(0);
					}
				} else if ($store.tokenType === "fa2_ft") {
					// FA2 contract with fungible tokens
					const contract = await $store.Tezos.wallet.at(config[$store.tokenType][$store.network]);

					const storage = await contract.storage();
					const balance = await storage.assets.ledger.get($store.userAddress);

					if (balance) {
						store.updateUserBalance(balance.toNumber());
					} else {
						store.updateUserBalance(0);
					}
				}
			} catch(error) {
				console.error(error);
			}
		} else {
			// disconnect user
			$store.Tezos.setWalletProvider(undefined);

			store.updateUserAddress(undefined);
			store.updateUserBalance(0);
		}
	};

	return [$store, connectWallet];
}

class ConnectWallet extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default ConnectWallet;